<template>
    <d2-container type="card" :filename="filename">
        <d2-crud
                :columns="columns"
                :data="data"
                :loading="loading"
                title="视频解析地址"
                add-mode
                :rowHandle="rowHandle"
                :pagination="pagination"
                :form-template="formTemplate"
                :form-options="formOptions"
                @row-add="handleRowAdd"
                @row-edit="handleRowEdit"
                @row-remove="handleRowRemove"
                @dialog-cancel="handleDialogCancel">
            <el-button slot="headerButton" @click="getData">
                <d2-icon name="refresh"></d2-icon>
            </el-button>
        </d2-crud>
    </d2-container>
</template>

<script>
    import VideoBtn from "@/pages/components/videoBtn.vue"
    export default {
        name: "index",
        components: {VideoBtn},
        data() {
            return {
                filename: __filename,
                loading: false,
                time: '',
                columns: [
                    {
                        title: 'ID',
                        key: 'id',
                    }, {
                        title: '标题',
                        key: 'title'
                    },
                    {
                        title: '接口',
                        key: 'url'
                    },
                    {
                        title: '预览',
                        key: 'view',
                        component: {
                            render: function (h, row) {
                                return h(VideoBtn, {
                                    attrs: {
                                        row: row
                                    }
                                })
                            }
                        },
                        width: '70'
                    },
                ],
                data: [],
                rowHandle: {
                    columnHeader: '操作',
                    edit: {
                        icon: 'el-icon-edit',
                        text: '编辑',
                        size: 'small',
                        disabled(index, row) {
                            if (row.forbidEdit) {
                                return true
                            }
                            return false
                        }
                    },
                    remove: {
                        icon: 'el-icon-delete',
                        size: 'small',
                        fixed: 'right',
                        confirm: true,
                        disabled(index, row) {
                            if (row.forbidRemove) {
                                return true
                            }
                            return false
                        }
                    },
                    custom: []
                },

                formTemplate: {
                    title: {
                        title: '标题',
                        value: '通用接口'
                    },
                    url: {
                        title: '接口',
                        value: '',
                    },

                },
                formOptions: {
                    labelWidth: '80px',
                    labelPosition: 'left',
                    saveLoading: false
                },
                pagination: {
                    pageSize: 10,
                    layout: 'prev, pager, next, total'
                }
            }
        },
        methods: {
            handleRowAdd(row, done) {
                this.formOptions.saveLoading = true
                this.$request({
                    url: 'createVideoUrl.do',  data: row
                }).then(res => {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    })
                    done()
                    this.formOptions.saveLoading = false
                }).catch((error) => {
                    this.msg = error
                    this.formOptions.saveLoading = false
                })
            },
            handleRowEdit({index, row}, done) {
                this.formOptions.saveLoading = true
                this.$request({
                    url: 'updateVideoUrlById.do', data: row,
                }).then(res => {
                    this.$message({
                        message: '编辑成功',
                        type: 'success'
                    })
                    done()
                    this.formOptions.saveLoading = false
                }).catch((error) => {
                    this.msg = error
                    this.formOptions.saveLoading = false
                })
            },
            handleDialogCancel(done) {
                this.$message({
                    message: '取消编辑',
                    type: 'warning'
                })
                done()
            },
            handleRowRemove({index, row}, done) {
                this.$request({
                    url: 'delVideoUrl.do', data: {
                        id: row.id
                    }
                }).then(res => {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    })
                    done()
                }).catch((error) => {
                    this.msg = error
                })
            },
            getData() {
                const _this = this
                this.loading = true
                this.$request({
                    url: 'getVideoUrls.do', method: 'post', data: {
                        action: 'getVideoUrl',
                    }
                }).then(res => {
                    _this.data = res
                    _this.loading = false
                })
                    .catch((error) => {
                        this.msg = error
                        _this.loading = false
                    })
            }
        }, created: function () {

            this.getData()
        }
    }
</script>

<style scoped>

</style>
